export const QUOTE_STATUS_COLORS: Record<string, string> = {
  pending_service_provider: 'blue',
  pending_customer: 'orange',
  accepted: 'green',
  customer_rejected: 'red',
  service_provider_rejected: 'volcano',
};

export const getQuoteStatusLabel = (status: string, t: (k: string) => string): string => {
  const map: Record<string, string> = {
    pending_service_provider: t('statusPendingSP'),
    pending_customer: t('statusPendingCustomer'),
    accepted: t('statusAccepted'),
    customer_rejected: t('statusCustomerRejected'),
    service_provider_rejected: t('statusSPRejected'),
  };
  return map[status] || status;
};

export const formatAmount = (value?: number, currency?: string): string => {
  const suffix = currency ? ` ${currency.toUpperCase()}` : '';
  return `${Number(value ?? 0).toFixed(2)}${suffix}`;
};
